import React from 'react';
import PropTypes from "prop-types";

const TosItem = (props) => {
    const {data, key} = props;

    return (
        <div className="tos__item" key={key}>
            <h3 className="tos__title">{data.title}</h3>
            <p className="tos__copy">{data.copy}</p>
        </div>
    );
};

TosItem.propTypes = {
    data: PropTypes.object.isRequired
};

export default TosItem;


// WEBPACK FOOTER //
// ./src/components/TermsOfService/TosItem.js